"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addDaysFns = require("date-fns/add_days");
var addMonthsFns = require("date-fns/add_months");
var compareAscFns = require("date-fns/compare_asc");
var eachDayFns = require("date-fns/each_day");
var endOfWeekFns = require("date-fns/end_of_week");
var getDayOfMonthFns = require("date-fns/get_date");
var getWeekDayFns = require("date-fns/get_day");
var getDaysInMonthFns = require("date-fns/get_days_in_month");
var getHoursFns = require("date-fns/get_hours");
var getMinutesFns = require("date-fns/get_minutes");
var isValidFns = require("date-fns/is_valid");
var getStartOfDayFns = require("date-fns/start_of_day");
var getStartOfMonthFns = require("date-fns/start_of_month");
var startOfWeekFns = require("date-fns/start_of_week");
var WEEKDAY;
(function (WEEKDAY) {
    WEEKDAY[WEEKDAY["SUNDAY"] = 0] = "SUNDAY";
    WEEKDAY[WEEKDAY["MONDAY"] = 1] = "MONDAY";
    WEEKDAY[WEEKDAY["TUESDAY"] = 2] = "TUESDAY";
    WEEKDAY[WEEKDAY["WEDNESDAY"] = 3] = "WEDNESDAY";
    WEEKDAY[WEEKDAY["THURSDAY"] = 4] = "THURSDAY";
    WEEKDAY[WEEKDAY["FRIDAY"] = 5] = "FRIDAY";
    WEEKDAY[WEEKDAY["SATURDAY"] = 6] = "SATURDAY";
})(WEEKDAY = exports.WEEKDAY || (exports.WEEKDAY = {}));
exports.DEFAULT_WEEK_START = WEEKDAY.MONDAY;
exports.getStartOfDay = function (date) { return getStartOfDayFns(date); };
exports.getStartOfMonth = function (date) { return getStartOfMonthFns(date); };
exports.getWeekDay = function (date) { return getWeekDayFns(date); };
exports.addDays = function (date, days) { return addDaysFns(date, days); };
exports.addMonths = function (date, months) { return addMonthsFns(date, months); };
exports.getDayOfMonth = function (date) { return getDayOfMonthFns(date); };
exports.compare = function (firstDate, secondDate) { return compareAscFns(firstDate, secondDate); };
exports.getHours = function (date) { return getHoursFns(date); };
exports.getMinutes = function (date) { return getMinutesFns(date); };
exports.getDaysInMonth = function (date) { return getDaysInMonthFns(date); };
exports.isValid = function (date) {
    return ['string', 'object'].includes(typeof date) && isValidFns(exports.getStartOfDay(date));
};
exports.sameMonth = function () {
    var dates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dates[_i] = arguments[_i];
    }
    return ensureValidDates(dates, function () {
        var firstDate = dates.shift();
        var firstStartOfMonth = exports.getStartOfMonth(firstDate);
        return dates.every(function (date) { return !exports.compare(exports.getStartOfMonth(date), firstStartOfMonth); });
    });
};
exports.sameDay = function () {
    var dates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        dates[_i] = arguments[_i];
    }
    return ensureValidDates(dates, function () {
        var firstDate = dates.shift();
        var firstStartOfDay = exports.getStartOfDay(firstDate);
        return dates.every(function (date) { return !exports.compare(exports.getStartOfDay(date), firstStartOfDay); });
    });
};
exports.getCalendarMonth = function (date, weekStartDay) {
    if (weekStartDay === void 0) { weekStartDay = exports.DEFAULT_WEEK_START; }
    var monthStartDay = exports.getStartOfMonth(date);
    var monthStartWeekDay = exports.getWeekDay(monthStartDay);
    var iteratedDate = exports.addDays(monthStartDay, monthStartWeekDay >= weekStartDay ? weekStartDay - monthStartWeekDay : weekStartDay - monthStartWeekDay - 7);
    var calendarWeeks = [];
    for (var week = 1; week <= 6; week++) {
        var calendarWeek = [];
        for (var weekDay = 1; weekDay <= exports.WEEK_LENGTH; weekDay++) {
            calendarWeek.push({
                date: iteratedDate,
                day: exports.getDayOfMonth(iteratedDate),
                weekDay: exports.getWeekDay(iteratedDate),
                isCurrentMonth: exports.sameMonth(monthStartDay, iteratedDate),
                today: exports.sameDay(iteratedDate, new Date()),
                past: exports.compare(iteratedDate, exports.getStartOfDay(new Date())) === -1
            });
            iteratedDate = exports.addDays(iteratedDate, 1);
        }
        calendarWeeks.push(calendarWeek);
    }
    return calendarWeeks;
};
exports.getCalendarWeek = function (date, weekStartDay) {
    if (weekStartDay === void 0) { weekStartDay = exports.DEFAULT_WEEK_START; }
    var currentWeekDay = exports.getWeekDay(date);
    var weekStartDelta = (currentWeekDay + exports.WEEK_LENGTH - weekStartDay) % exports.WEEK_LENGTH;
    var startDate = exports.addDays(date, -1 * weekStartDelta);
    var result = [];
    var weekDay = weekStartDay;
    var iteratedDate = startDate;
    for (var i = 0; i < exports.WEEK_LENGTH; i++) {
        result.push({
            date: iteratedDate,
            day: exports.getDayOfMonth(iteratedDate),
            weekDay: weekDay,
            isCurrentMonth: exports.sameMonth(iteratedDate, date),
            today: exports.sameDay(iteratedDate, new Date()),
            past: exports.compare(iteratedDate, exports.getStartOfDay(new Date())) === -1
        });
        weekDay = (weekDay + 1) % exports.WEEK_LENGTH;
        iteratedDate = exports.addDays(iteratedDate, 1);
    }
    return result;
};
exports.getWeekDayNames = function (locale, weekStartDay) {
    if (locale === void 0) { locale = 'en'; }
    if (weekStartDay === void 0) { weekStartDay = exports.DEFAULT_WEEK_START; }
    var now = new Date();
    var weekDates = eachDayFns(startOfWeekFns(now), endOfWeekFns(now));
    var weekDayNames = weekDates.reduce(function (names, date) {
        names.push(new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date));
        return names;
    }, []);
    // Rotate week to start as needed
    var endOfWeek = weekDayNames.splice(0, weekStartDay);
    endOfWeek.forEach(function (day) { return weekDayNames.push(day); });
    return weekDayNames;
};
exports.getTimeText = function (date, locale) {
    if (locale === void 0) { locale = 'en'; }
    var intl = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' });
    return intl.format(date);
};
exports.getFullMonthText = function (date, locale) {
    if (locale === void 0) { locale = 'en'; }
    var intl = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long' });
    return intl.format(date);
};
exports.getDayMonthText = function (date, locale) {
    if (locale === void 0) { locale = 'en'; }
    var intl = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long' });
    return intl.format(date);
};
exports.WEEK_LENGTH = 7;
exports.WEEKS_PER_CALENDAR_MONTH = 6;
var ensureValidDates = function (args, cb, errorResponse) {
    if (errorResponse === void 0) { errorResponse = false; }
    if (!args.every(function (testedDate) { return exports.isValid(testedDate); })) {
        return errorResponse;
    }
    return cb();
};
var MONTH;
(function (MONTH) {
    MONTH[MONTH["JANUARY"] = 0] = "JANUARY";
    MONTH[MONTH["FEBRUARY"] = 1] = "FEBRUARY";
    MONTH[MONTH["MARCH"] = 2] = "MARCH";
    MONTH[MONTH["APRIL"] = 3] = "APRIL";
    MONTH[MONTH["MAY"] = 4] = "MAY";
    MONTH[MONTH["JUNE"] = 5] = "JUNE";
    MONTH[MONTH["JULY"] = 6] = "JULY";
    MONTH[MONTH["AUGUST"] = 7] = "AUGUST";
    MONTH[MONTH["SEPTEMBER"] = 8] = "SEPTEMBER";
    MONTH[MONTH["OCTOBER"] = 9] = "OCTOBER";
    MONTH[MONTH["NOVEMBER"] = 10] = "NOVEMBER";
    MONTH[MONTH["DECEMBER"] = 11] = "DECEMBER";
})(MONTH = exports.MONTH || (exports.MONTH = {}));
